import { IonList, IonItem, IonIcon, IonText } from '@ionic/react';
import { cog, copy, trash } from 'ionicons/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { userInfoSelector } from 'selectors/userSelector';

import ProjectActions from 'actions/ProjectActions';

import ReportButton from './ReportButton';
import LogsDownloadButton from './logs/LogsDownloadButton';

// TODO: Implement IonAlert for confirm for better UI/UX; consider implementing ionic helper: confirm(message, onConfirmHandler) that expects click event;/withI

export default function ProjectMenu({project, setErrorMsg=_.noop}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const {global_editor=false} = useSelector(userInfoSelector);
  const deleteProject = async () => {
    if (window.confirm(`Are you sure you want to delete '${project?.name}'`)) {
      try {
        const result = await dispatch(ProjectActions.deleteProject(project?.id));
        const errors = result?.errors;
        if (errors) throw new Error(errors instanceof Object ? (errors?.error ?? errors?.errors) : errors);
        history.push('/projects');
      } catch (e) {
        setErrorMsg(e.toString());
      }
    }
  };
  const logsPresent = !_.isEmpty(_.get(project, 'data.logs.loads'));

  return <>
    <IonList lines="full">
      <ReportButton project={project}/>
      {logsPresent && (
        <LogsDownloadButton BtnComponent={IonItem} text="Download Logs (pdf)" iconSlot="start"/>
      )}
      {(global_editor || project?.owned) && (
        <IonItem routerLink={`/projects/${project?.id}/settings`} detail="false">
          <IonIcon icon={cog} slot="start"/>
          Edit Project
        </IonItem>
      )}
      <IonItem routerLink={`/projects/${project?.id}/copy`} detail="false">
        <IonIcon icon={copy} slot="start"/>
        Copy Project
      </IonItem>
      {(project?.id && project?.owned) && (
        <IonItem lines="none" onClick={deleteProject} button detail={false}>
          <IonIcon icon={trash} slot="start" color="danger"/>
          <IonText color="danger">Delete Project</IonText>
        </IonItem>
      )}
    </IonList>
  </>;
}
